import Axios from 'axios';
import { jwtDecode } from "jwt-decode";
import store from '../../redux/store';
import { getBasicAuth, getClientBasicAuth } from '../env-config';
import { LABELS } from '../../utilities/constants/index';
// eslint-disable-next-line import/no-cycle
import { gotoLoginPage, showInfoMessageAlert } from '../../utilities/utility';
import { getLoginRes } from '../../services/auth-details-service';
import { oauthToken } from '../../actions/api-actions';
import logger from '../../services/logger';

// Create an Axios instance
const http = Axios.create({
  headers: {
    'Content-type': 'application/json',
  },
});

// Request interceptor
http.interceptors.request.use((config) => {
  let authorizationToken = '';
  const loginUserData = getLoginRes();

  if (config?.data?.grant_type === LABELS.GRANT_TYPE.CLIENT_CREDENTIALS) {
    // Use client basic auth for client_credentials grant type
    authorizationToken = `Basic ${getClientBasicAuth()}`;
  } else if (config?.data?.grant_type === LABELS.GRANT_TYPE.PASSWORD) {
    // Use basic auth for password grant type
    authorizationToken = `Basic ${getBasicAuth()}`;
  } else {
    // Get the access token from the store state
    const accessToken = loginUserData?.access_token;
    const bizAccessToken = store.getState().biz.bizAccessToken?.access_token;

    if (accessToken !== '' && accessToken !== undefined) {
      authorizationToken = accessToken ? `Bearer ${accessToken}` : '';
    }

    if (bizAccessToken !== '' && bizAccessToken !== undefined) {
      authorizationToken = bizAccessToken ? `Bearer ${bizAccessToken}` : '';
    }
  }

  if (authorizationToken !== '' && authorizationToken !== undefined) {
    // Set the Authorization header
    config.headers.Authorization = authorizationToken;
  }
  if (config.url.includes('pong')) {
    // Delete the authorization token for pong request
    delete config.headers.Authorization;
  }

  return config;
});

// Response interceptor
http.interceptors.response.use(
  (response) => {
    // Extract the properties from the response object
    // This handles Authentication bypass using response manipulation
    if(response?.data?.access_token){
      if(response?.config?.url?.includes("uaa/oauth/token") && response?.config?.data && (!response.config.data.grant_type || response.config.data.grant_type === "password")){
        const respAccessTokenObj = jwtDecode(response.data.access_token);
        let isValidLogin = false;
        console.log('interceptors::', respAccessTokenObj); // Outputs the payload of the JWT
        const reqPayload = JSON.parse(response.config.data || null) || {};
        if(reqPayload.username && respAccessTokenObj?.user_name){
          const userArray = respAccessTokenObj.user_name.split('/') || [];
          if(reqPayload.username.includes("/")){
            isValidLogin = reqPayload.username === respAccessTokenObj.user_name;
          }else{
            isValidLogin = reqPayload.username === userArray[0];
          }
          const [, realm] = userArray;
          response.data.realm = realm;
        }
        if(!isValidLogin){
          return {"error":"invalid_grant","error_description":"Bad credentials"};
        }
      }
    }
    return response;
  },
  async (error) => {
    // Extract the properties from the error response object
    const { status, config } = error?.response || {};

    switch (status) {
      case 400:
        // Handle 400 status code
        break;
      case 401:
        // Handle 401 status code
        console.log('error', error?.response?.data?.error);
        if (error?.response?.data?.error === 'invalid_token') {
          try {
            // Call the revoke API
            const payload = {
              refresh_token: getLoginRes()?.refresh_token,
              grant_type: 'refresh_token',
            };
            const oauthTokenData = await oauthToken(payload); // Replace with the actual function to revoke the token
            if (oauthTokenData?.status === 200) {
              // Retry the failed request with updated authorization
              logger.info('Retrying the failed request with updated authorization', config);
              return http(config);
            }
            // If revoking token fails, redirect to the login page
            showInfoMessageAlert('Your session has expired. Please login again.');
            gotoLoginPage();

          } catch (revokeError) {
            // If revoking token fails, redirect to the login page
            showInfoMessageAlert('Your session has expired. Please login again.');
            gotoLoginPage();
          }
        }
        break;
      case 403:
        // Handle 401 status code
        if (error?.response?.data?.error === 'Forbidden') {
          showInfoMessageAlert('Your session is invalid, please re-login...!');
          gotoLoginPage();
        }
        break;
      case 404:
        // Handle 404 status code
        break;
      case 422:
        // Handle 422 status code
        break;
      case 429:
        // Handle 429 status code
        showInfoMessageAlert('Too many requests...please try again later');
        break;
      case 500:
        showInfoMessageAlert('Something went wrong...please try to refresh and check');
        // Handle 500 status code
        break;
      default:
        // Handle other status codes
        break;
    }

    return error?.response;
  },
);

export default http;
